module.exports = __webpack_public_path__ + "static/media/application-data-sheet.3dfdc8fb.pdf";